import { render } from "./BoxWithLatestNews.vue?vue&type=template&id=8bb02778&scoped=true&ts=true"
import script from "./BoxWithLatestNews.vue?vue&type=script&lang=ts"
export * from "./BoxWithLatestNews.vue?vue&type=script&lang=ts"

import "./BoxWithLatestNews.vue?vue&type=style&index=0&id=8bb02778&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb02778"]])

export default __exports__